// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"115":"39ab4764","164":"7c40a264","231":"60a14fc1","893":"b40f3e88","960":"bc483d49","986":"e09df60b"}[chunkId] + ".js";
};